import store from '@/store'
import utils from '@/js/utils'
import Materials from '@/js/Materials'

export default class MasterPricing {
  static calculatePriceForMaterial(material, area, perimeter, sheets, items) {
    const sheetCost = Materials.getSheetCostFromProperties(
      material,
      material.w,
      material.h,
      material.thickness,
      material.sides
    )

    if (!sheetCost) return false

    // If whole sheets not specified calculate on area used only eg - Ürtil doors
    if (!sheets) {
      sheets = utils.toFixedNumber(area / (material.w * material.h) / 1000000, 2)
    }

    // Sheet
    const sheetsCost = sheetCost * sheets
    const cadCost =
      material.grainDirection && material.continuousGrain
        ? store.state.pricing.costs.cadPerSheetWithGrain.value
        : store.state.pricing.costs.cadPerSheet.value
    const cad = sheets * cadCost

    // Edge
    const machining = (perimeter / 1000) * store.state.pricing.costs.cutCostPerM.value
    const edgeSand = (perimeter / 1000) * store.state.pricing.costs.edgeSandPerM.value
    const edgeOsmo = material.grainDirection ? 0 : (perimeter / 1000) * store.state.pricing.costs.edgeOsmoPerM.value

    // Face
    const faceSand = material.grainDirection
      ? (area / 1000000) * store.state.pricing.costs.surfaceSandPerM2.value * 2
      : 0
    const faceLaquer =
      material.grainDirection && !material.unfinished
        ? (area / 1000000) * store.state.pricing.costs.lacquerPerM2.value * 2
        : 0

    // Pack & Crate
    const packCrate = items * store.state.pricing.costs.packCratePerItem.value

    const external = utils.toFixedNumber(sheetsCost + faceLaquer, 2)
    const internal = utils.toFixedNumber(cad + machining + edgeSand + edgeOsmo + faceSand + packCrate, 2)
    const total = utils.toFixedNumber(
      internal * store.state.pricing.ukMultiplier.internalMarkup.value +
        external * store.state.pricing.ukMultiplier.externalMarkup.value,
      2
    )

    return {
      internal,
      external,
      total,
      profit: {
        margin: utils.toFixedNumber(total - (internal + external), 2) // unused data
      }
    }
  }

  static calculateUsPriceForMaterial(material, area, perimeter, requiredSheetsRounded) {
    const mmPerFoot = 304.8
    const sqMmPerSqFoot = 92903.04

    // Sheet
    const sheetCost = Materials.getSheetCostFromProperties(
      material,
      material.w,
      material.h,
      material.thickness,
      material.sides
    )

    if (!sheetCost) return false

    // Material
    const materialCost = utils.toFixedNumber(sheetCost * requiredSheetsRounded, 2) // extrapolate the cost of the material

    const programmingCost = utils.toFixedNumber(
      requiredSheetsRounded * store.state.pricing.usCosts.programmingPerSheet.value * 2, // $100 for US Urtil
      2
    )
    const cuttingCost = utils.toFixedNumber(
      (perimeter / mmPerFoot) * store.state.pricing.usCosts.cuttingPerFoot.value,
      2
    )
    const edgeFinishingCost = utils.toFixedNumber(
      (perimeter / mmPerFoot) * store.state.pricing.usCosts.edgeFinishPerFoot.value,
      2
    )
    const surfaceFinishingCost = utils.toFixedNumber(
      material && material.hasGrain
        ? (area / sqMmPerSqFoot) * store.state.pricing.usCosts.faceFinishPerSqFoot.value
        : 0,
      2
    )
    let finishingCost = material.hasGrain
      ? utils.toFixedNumber(edgeFinishingCost + surfaceFinishingCost, 2)
      : utils.toFixedNumber(edgeFinishingCost, 2)

    if (material.unfinished) finishingCost *= 0.2

    // PACK AND CRATE PER SQUARE FOOT
    const packagingPerSqFt = utils.toFixedNumber(
      (area / sqMmPerSqFoot) * store.state.pricing.usCosts.packAndCratePerSqFoot.value,
      2
    )

    const cost = utils.toFixedNumber(materialCost + programmingCost + cuttingCost + finishingCost, 2)
    const total = utils.toFixedNumber(cost * store.state.pricing.usMultiplier.lucidMarkup.value + packagingPerSqFt, 2)

    return {
      details: {
        id: material.id,
        size: material.size,
        materialName: material.value,
        requiredSheetsRounded,
        perimeterFt: perimeter / mmPerFoot,
        areaSqFt: area / sqMmPerSqFoot,
        materialCost,
        programmingCost,
        cuttingCost,
        edgeFinishingCost,
        surfaceFinishingCost,
        finishingCost,
        packagingPerSqFt
      },
      cost,
      total
    }
  }

  static getHandle(value) {
    let h = null
    // handles is null until App.vue's snapshot lands
    ;(store.state.handles || []).find((handle) => {
      if (handle.value === value) {
        h = handle
      }
    })
    return h
  }
}
